import { render, staticRenderFns } from "./PlotlyPlot.vue?vue&type=template&id=389cae01&"
import script from "./PlotlyPlot.vue?vue&type=script&lang=ts&"
export * from "./PlotlyPlot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports